<template>
    <section class="ccard">
        <div class="ccard-head">
            <img v-if="mascot" :src="mascot" alt="" class="masc">
            <h2 class="ccard-title">{{ title }}</h2>
            <button type="button" class="ghost-btn sm" :aria-expanded="open ? 'true' : 'false'" :aria-controls="id"
                    @click="$emit('update:open', !open)">
                <svg class="chev" width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M2 4l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
                {{ open ? 'Masquer' : 'Afficher' }}
            </button>
        </div>
        <p v-if="subtitle && open" class="ccard-sub">{{ subtitle }}</p>
        <div class="ccard-body" :id="id" :hidden="!open">
            <slot></slot>
        </div>
    </section>
</template>

<script>
export default {
    name: 'CollapsibleCard',
    props: {
        title: {type: String, required: true},
        subtitle: {type: String, default: ''},
        mascot: {type: String, default: ''},
        open: {type: Boolean, default: true},
        id: {type: String, required: true},
    },
};
</script>
